import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { withTheme } from '@gn-audio/jss-components';

import { BentoGridComponent } from 'composables/Product/BentoGrid/BentoGridComponent';
import { BentoGridProps } from 'composables/Product/BentoGrid/types';

const BentoGrid = ({ fields }: BentoGridProps) => {
  const items = fields.items || [];

  return (
    <BentoGridComponent
      items={items}
      trackingSpotName={fields.trackingSpotName?.value}
    ></BentoGridComponent>
  );
};

export default withTheme({
  defaultTheme: {
    backgroundColor: '#627776',
    foregroundColor: 'white',
    darkTheme: true,
  },
})(withDatasourceCheck()<BentoGridProps>(BentoGrid));
